<template>
  <DialogBase
    :visible.sync="visible"
    :title="dialogTitle"
    width="560px"
    :use-panel="false"
    @cancel="handleClose"
  >
    <div class="sk-dialog__content">
      <!-- ══════════════════════════════════════════
           THANH CHỌN TÁC VỤ: 2 LỰA CHỌN
           ══════════════════════════════════════════ -->
      <div class="rfd-action-switch">
        <button
          type="button"
          class="rfd-switch-btn"
          :class="{ 'is-active': actionType === 'rename' }"
          @click="actionType = 'rename'"
        >
          <i class="el-icon-edit-outline" />
          <span>Đổi tên khoản thu</span>
        </button>
        <button
          type="button"
          class="rfd-switch-btn rfd-switch-btn--danger"
          :class="{ 'is-active': actionType === 'delete' }"
          @click="actionType = 'delete'"
        >
          <i class="el-icon-delete" />
          <span>Xóa khoản thu</span>
        </button>
      </div>

      <!-- ══════════════════════════════════════════
           LỰA CHỌN 1: ĐỔI TÊN KHOẢN THU
           ══════════════════════════════════════════ -->
      <div v-show="actionType === 'rename'">
        <!-- Thông tin khoản thu hiện tại -->
        <div class="sk-panel">
          <div class="sk-panel-head">
            <div class="sk-panel-icon">
              <i class="el-icon-collection-tag" />
            </div>
            <div>
              <p class="sk-panel-title">Thông tin khoản thu hiện tại</p>
              <p class="sk-panel-subtitle">Khoản thu đang áp dụng trong danh sách phiếu thu</p>
            </div>
          </div>

          <div class="rfd-info-grid">
            <div class="rfd-info-row">
              <span class="rfd-info-label">Mã khoản:</span>
              <el-tag size="mini" type="info" effect="plain" class="rfd-info-code">
                {{ feeData.revenueCode || feeData.idx || '—' }}
              </el-tag>
            </div>
            <div class="rfd-info-row">
              <span class="rfd-info-label">Tên hiện tại:</span>
              <span class="rfd-info-name">{{ feeData.currentName || feeData.label || '—' }}</span>
            </div>
            <div class="rfd-info-row">
              <span class="rfd-info-label">Đơn vị tính:</span>
              <span class="rfd-info-value">{{ feeData.unit || 'Tháng' }}</span>
            </div>
            <div v-if="feeData.price" class="rfd-info-row">
              <span class="rfd-info-label">Đơn giá mẫu:</span>
              <span class="rfd-info-value">{{ feeData.price | formatCurrency }}</span>
            </div>
            <div class="rfd-info-row">
              <span class="rfd-info-label">Phạm vi:</span>
              <span class="rfd-info-value">
                {{ feeData.targetType === 'GROUP' ? 'Nhóm' : 'Lớp' }}
                {{ feeData.targetName || feeData.className || '—' }}
              </span>
            </div>
            <div class="rfd-info-row">
              <span class="rfd-info-label">Kỳ áp dụng:</span>
              <span class="rfd-info-value">
                Tháng {{ feeData.month }}/{{ feeData.year }} (Đợt {{ feeData.turn }})
              </span>
            </div>
          </div>
        </div>

        <!-- Thiết lập tên mới -->
        <div class="sk-panel sk-u-mt-12">
          <div class="sk-panel-head">
            <div class="sk-panel-icon sk-panel-icon--success">
              <i class="el-icon-edit" />
            </div>
            <div>
              <p class="sk-panel-title">Thiết lập tên mới</p>
              <p class="sk-panel-subtitle">Nhập tên hiển thị mới cho khoản thu này</p>
            </div>
          </div>

          <el-form
            ref="formRef"
            :model="formData"
            :rules="formRules"
            label-position="top"
          >
            <el-form-item label="Tên khoản thu mới" prop="newName">
              <el-input
                v-model="formData.newName"
                placeholder="Nhập tên khoản thu mới..."
                maxlength="150"
                show-word-limit
                clearable
                @keyup.enter.native="handleSave"
              />
            </el-form-item>

            <el-form-item label="Ghi chú điều chỉnh (tùy chọn)" prop="note" class="sk-u-mt-12">
              <el-input
                v-model="formData.note"
                type="textarea"
                :rows="2"
                placeholder="Nhập lý do thay đổi tên..."
                maxlength="250"
                show-word-limit
              />
            </el-form-item>
          </el-form>
        </div>

        <!-- Ghi chú / Cảnh báo đổi tên -->
        <div class="sk-note sk-note--warning sk-u-mt-12">
          <i class="el-icon-warning-outline" />
          <span>
            Tên khoản thu sẽ được thay đổi cho tất cả các phiếu thu đã được khởi tạo của
            {{ feeData.targetType === 'GROUP' ? 'nhóm' : 'lớp' }}
            <strong v-if="feeData.targetName || feeData.className">
              {{ feeData.targetName || feeData.className }}
            </strong>
            trong tháng <strong>{{ feeData.month || '...' }}/{{ feeData.year || '...' }}</strong>
            đợt <strong>{{ feeData.turn || '...' }}</strong>.
          </span>
        </div>
      </div>

      <!-- ══════════════════════════════════════════
           LỰA CHỌN 2: XÓA KHOẢN THU
           ══════════════════════════════════════════ -->
      <div v-show="actionType === 'delete'">
        <!-- Thông tin khoản thu cần xóa -->
        <div class="sk-panel">
          <div class="sk-panel-head">
            <div class="sk-panel-icon sk-panel-icon--danger">
              <i class="el-icon-warning-outline" />
            </div>
            <div>
              <p class="sk-panel-title">Thông tin khoản thu cần xóa</p>
              <p class="sk-panel-subtitle">Khoản thu này sẽ bị gỡ bỏ khỏi toàn bộ phiếu thu trong phạm vi</p>
            </div>
          </div>

          <div class="rfd-info-grid">
            <div class="rfd-info-row">
              <span class="rfd-info-label">Mã khoản:</span>
              <el-tag size="mini" type="danger" effect="plain" class="rfd-info-code">
                {{ feeData.revenueCode || feeData.idx || '—' }}
              </el-tag>
            </div>
            <div class="rfd-info-row">
              <span class="rfd-info-label">Tên khoản thu:</span>
              <span class="rfd-info-name rfd-info-name--danger">
                {{ feeData.currentName || feeData.label || '—' }}
              </span>
            </div>
            <div class="rfd-info-row">
              <span class="rfd-info-label">Đơn vị tính:</span>
              <span class="rfd-info-value">{{ feeData.unit || 'Tháng' }}</span>
            </div>
            <div v-if="feeData.price" class="rfd-info-row">
              <span class="rfd-info-label">Đơn giá mẫu:</span>
              <span class="rfd-info-value">{{ feeData.price | formatCurrency }}</span>
            </div>
            <div class="rfd-info-row">
              <span class="rfd-info-label">Phạm vi:</span>
              <span class="rfd-info-value">
                {{ feeData.targetType === 'GROUP' ? 'Nhóm' : 'Lớp' }}
                {{ feeData.targetName || feeData.className || '—' }}
              </span>
            </div>
            <div class="rfd-info-row">
              <span class="rfd-info-label">Kỳ áp dụng:</span>
              <span class="rfd-info-value">
                Tháng {{ feeData.month }}/{{ feeData.year }} (Đợt {{ feeData.turn }})
              </span>
            </div>
          </div>
        </div>

        <!-- Cảnh báo nguy hiểm khi xóa -->
        <div class="sk-note sk-note--danger sk-u-mt-12">
          <i class="el-icon-warning" />
          <div class="rfd-danger-desc">
            <p>
              <strong>Cảnh báo quan trọng:</strong> Hành động này sẽ xóa khoản thu
              <strong>"{{ feeData.currentName || feeData.label }}"</strong> (mã: <strong>{{ feeData.revenueCode }}</strong>)
              khỏi <strong>TẤT CẢ</strong> phiếu thu đã được khởi tạo của
              {{ feeData.targetType === 'GROUP' ? 'nhóm' : 'lớp' }}
              <strong>{{ feeData.targetName || feeData.className }}</strong>
              trong tháng <strong>{{ feeData.month }}/{{ feeData.year }}</strong> đợt <strong>{{ feeData.turn }}</strong>.
            </p>
            <p class="sk-u-mt-6">
              Nếu có bất kỳ phiếu thu chứa khoản này đã thanh toán (kể cả một phần), hệ thống sẽ chặn xóa trên toàn bộ phạm vi. Khi được phép xóa, tổng tiền và số dư của phiếu sẽ được tính lại.
            </p>
            <p class="rfd-danger-highlight sk-u-mt-6">
              <i class="el-icon-error" /> Thao tác này không thể hoàn tác! Bạn có chắc chắn muốn xóa không?
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- ══════════════════════════════════════════
         FOOTER DIALOG
         ══════════════════════════════════════════ -->
    <template #footer>
      <div class="sk-dialog__footer">
        <el-button class="btn-cancel" plain @click="handleClose">Hủy</el-button>

        <!-- Nút khi chọn Đổi tên -->
        <el-button
          v-if="actionType === 'rename'"
          class="btn-save"
          type="primary"
          :disabled="!isNameChanged"
          :loading="isSaving"
          @click="handleSave"
        >
          <i class="el-icon-check" /> Lưu thay đổi
        </el-button>

        <!-- Nút khi chọn Xóa -->
        <el-button
          v-if="actionType === 'delete'"
          class="btn-delete"
          type="danger"
          :loading="isDeleting"
          @click="handleDelete"
        >
          <i class="el-icon-delete" /> Xác nhận xóa khoản thu
        </el-button>
      </div>
    </template>
  </DialogBase>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import ManagingStudentInvoiceService from "@/services/tutition_v3/ManagingStudentInvoiceService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "RenameFeeDialog",
  components: {
    DialogBase,
  },
  filters: {
    formatCurrency(val) {
      if (val === null || val === undefined || val === "") return "0 đ";
      const num = Number(val);
      if (isNaN(num)) return val;
      return num.toLocaleString("vi-VN") + " đ";
    },
  },
  computed: {
    dialogTitle() {
      return this.actionType === "delete" ? "Xóa khoản thu" : "Đổi tên khoản thu";
    },
    isNameChanged() {
      const oldName = (this.feeData.currentName || "").trim();
      const newName = (this.formData.newName || "").trim();
      return newName.length > 0 && newName !== oldName;
    },
  },
  data() {
    // Custom validator checking if new name is identical to current name
    const validateNewName = (rule, value, callback) => {
      const trimmed = (value || "").trim();
      if (!trimmed) {
        return callback(new Error("Vui lòng nhập tên khoản thu mới"));
      }
      if (trimmed === (this.feeData.currentName || "").trim()) {
        return callback(new Error("Tên mới không được trùng với tên hiện tại"));
      }
      callback();
    };

    return {
      visible: false,
      actionType: "rename", // 'rename' | 'delete'
      isSaving: false,
      isDeleting: false,
      feeData: {
        key: "",
        prop: "",
        revenueCode: "",
        idx: "",
        currentName: "",
        label: "",
        unit: "",
        price: 0,
        targetId: null,
        targetType: "CLASS",
        targetName: "",
        className: "",
        month: "",
        year: "",
        turn: "",
      },
      formData: {
        newName: "",
        note: "",
      },
      formRules: {
        newName: [
          { required: true, validator: validateNewName, trigger: "blur" },
          { min: 2, max: 150, message: "Độ dài từ 2 đến 150 ký tự", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    /**
     * Mở dialog thao tác khoản thu (đổi tên / xóa)
     * @param {Object} item - Thông tin cột khoản thu (từ feeColumns)
     * @param {Object} context - Thông tin ngữ cảnh bổ sung (lớp/nhóm, đợt, tháng, năm...)
     * @param {string} initialAction - 'rename' | 'delete'
     */
    open(item = {}, context = {}, initialAction = "rename") {
      const currentName = item.label || item.revenueName || "";
      this.actionType = initialAction === "delete" ? "delete" : "rename";
      this.feeData = {
        key: item.key || item.revenueCode || "",
        prop: item.prop || "",
        revenueCode: item.revenueCode || item.key || "",
        idx: item.idx || "",
        currentName: currentName,
        label: currentName,
        unit: item.unit || "Tháng",
        price: item.price || 0,
        targetId: context.targetId || null,
        targetType: context.targetType || "CLASS",
        targetName: context.targetName || context.className || "",
        className: context.targetName || context.className || "",
        month: context.month || "",
        year: context.year || "",
        turn: context.turn !== undefined && context.turn !== null ? context.turn : "",
      };

      this.formData = {
        newName: currentName,
        note: "",
      };

      this.visible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },

    handleClose() {
      this.visible = false;
      this.isSaving = false;
      this.isDeleting = false;
      this.$emit("close");
    },

    handleSave() {
      if (this.isSaving || !this.isNameChanged || !this.$refs.formRef) return;

      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return;

        this.isSaving = true;
        const payload = {
          revenueCode: this.feeData.revenueCode,
          oldRevenueName: this.feeData.currentName,
          newRevenueName: this.formData.newName.trim(),
          targetId: Number(this.feeData.targetId),
          targetType: this.feeData.targetType,
          month: Number(this.feeData.month),
          year: Number(this.feeData.year),
          turn: Number(this.feeData.turn),
          note: this.formData.note.trim(),
        };
        try {
          const response = await ManagingStudentInvoiceService.renameFee(payload);
          const result = response?.data?.data;
          if (!result || typeof result.updatedInvoiceCount !== "number") {
            throw new Error("API đổi tên khoản thu không trả kết quả hợp lệ.");
          }
          this.$emit("saved", { ...payload, ...result });
          this.visible = false;
        } catch (error) {
          let errorData = error?.response?.data;
          if (typeof errorData === "string") {
            try { errorData = JSON.parse(errorData); } catch (_) { /* Giữ thông báo gốc. */ }
          }
          const message = errorData?.message || (typeof errorData === "string" ? errorData : null)
            || error?.message || "Không thể đổi tên khoản thu.";
          NotifyMessage.leftCornerNotificationError(typeof message === "string" ? message : JSON.stringify(message));
          this.$emit("refresh");
        } finally {
          this.isSaving = false;
        }
      });
    },

    async handleDelete() {
      if (this.isDeleting) return;

      try {
        await this.$confirm(
          `Bạn có chắc chắn muốn xóa vĩnh viễn khoản thu "${this.feeData.currentName}" khỏi tất cả các phiếu thu không?`,
          "Xác nhận xóa khoản thu",
          {
            confirmButtonText: "Đồng ý xóa",
            cancelButtonText: "Hủy",
            type: "warning",
            confirmButtonClass: "el-button--danger",
          }
        );
      } catch (_) {
        return;
      }

      this.isDeleting = true;
      const payload = {
        targetType: this.feeData.targetType,
        targetId: Number(this.feeData.targetId),
        month: Number(this.feeData.month),
        year: Number(this.feeData.year),
        turn: Number(this.feeData.turn),
        revenueCode: this.feeData.revenueCode,
      };

      try {
        const response = await ManagingStudentInvoiceService.deleteFee(payload);
        const result = response?.data?.data;
        if (!result || typeof result.updatedInvoiceCount !== "number") {
          throw new Error("API xóa khoản thu không trả kết quả hợp lệ.");
        }
        this.$emit("deleted", {
          ...payload,
          ...result,
          label: this.feeData.currentName || this.feeData.label,
        });
        this.visible = false;
      } catch (error) {
        let errorData = error?.response?.data;
        if (typeof errorData === "string") {
          try { errorData = JSON.parse(errorData); } catch (_) { /* Giữ thông báo gốc. */ }
        }
        const message = errorData?.message || (typeof errorData === "string" ? errorData : null)
          || error?.message || "Không thể xóa khoản thu.";
        NotifyMessage.leftCornerNotificationError(typeof message === "string" ? message : JSON.stringify(message));
        this.$emit("refresh");
      } finally {
        this.isDeleting = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-dialog.scss";

.rfd-action-switch {
  display: flex;
  background: #f1f5f9;
  padding: 4px;
  border-radius: 12px;
  gap: 6px;
  border: 1px solid #e2e8f0;
  margin-bottom: 16px;
}

.rfd-switch-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 9px;
  border: none;
  background: transparent;
  color: #64748b;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  i {
    font-size: 15px;
  }

  &:hover:not(.is-active) {
    color: #1e293b;
    background: rgba(255, 255, 255, 0.6);
  }

  &.is-active {
    background: #ffffff;
    color: #2563eb;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
    font-weight: 700;
  }

  &--danger.is-active {
    background: #ffffff;
    color: #dc2626;
    box-shadow: 0 1px 3px rgba(220, 38, 38, 0.15), 0 1px 2px rgba(220, 38, 38, 0.1);
  }
}

.rfd-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 10px;
  column-gap: 16px;
  background: #ffffff;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid #f1f5f9;
}

.rfd-info-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  min-width: 0;

  &:nth-child(2) {
    grid-column: 1 / -1;
  }
}

.rfd-info-label {
  color: #64748b;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
}

.rfd-info-code {
  font-family: monospace;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.rfd-info-name {
  color: #1e293b;
  font-weight: 700;
  font-size: 14px;
  word-break: break-word;

  &--danger {
    color: #dc2626;
  }
}

.rfd-info-value {
  color: #334155;
  font-weight: 600;
}

.rfd-danger-desc {
  flex: 1;
  font-size: 13px;
  line-height: 1.5;

  p {
    margin: 0;
  }
}

.rfd-danger-highlight {
  color: #dc2626;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 6px;
}

@media (max-width: 640px) {
  .rfd-info-grid {
    grid-template-columns: 1fr;
  }
}
</style>
